import { enablePageScroll } from 'scroll-lock';

const $ = jQuery.noConflict();

class Header {
    constructor() {
        this.header = '.main-header';
        this.submenuLink = '.main-header__nav li.menu-item-has-children > a';
        this.submenuClass = '.sub-menu';
    }

    init() {
        this.submenu();
        this.resized();
    }

    submenu() {
        $(this.submenuLink).on(
            'click',
            event => {
                event.preventDefault();
                $(event.currentTarget).toggleClass('active').next().slideToggle(200);

                if ($(event.currentTarget).hasClass('active') && $('.search-modal').is(':visible')) {
                    enablePageScroll();
                    $('.search-modal').slideUp(200);
                }
            }
        );
    }

    hideOutsideClick(e) {
        $(this.submenuClass).each(
            (index, el) => {
                if ($(el).parents('.main-header__nav').length === 1 && $(el).is(':visible') && $(el).parent('.menu-item-has-children').has(e.target).length === 0) {
                    $(el).slideUp(200);
                    $(el).prev().removeClass('active');
                }
            }
        );
    }

    resized() {
        if ($(this.stickyBar).length) {
            $(this.stickyBar).css({ 'top': $('.main-header').height() });
        }
    }
}

export default new Header();
